<template>
    <aside class="justify-self-center">
        <nav
            class="inline-flex items-center justify-center p-1 space-x-1 overflow-hidden text-sm text-gray-600 bg-gray-100 rounded-xl"
        >
            <template v-for="link in links">
                <template v-if="link.selected">
                    <AppButton :href="link.url" element="inertia-link" :key="link.url">
                        {{ link.display_name }}
                    </AppButton>
                </template>
                <template v-else>
                    <InertiaLink
                        :href="link.url"
                        :key="link.url"
                        class="inline-flex items-center h-8 px-3 font-medium transition rounded-lg hover:text-gray-800 focus:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-inset"
                    >
                        {{ link.display_name }}
                    </InertiaLink>
                </template>
            </template>
        </nav>
    </aside>
</template>
<script>
import AppButton from '@/components/AppButton.vue';
import { Link as InertiaLink } from '@inertiajs/vue3';

export default {
    name: 'NavLinks',
    components: {
        AppButton,
        InertiaLink,
    },
    props: {
        links: {},
    },
};
</script>
